import React from 'react';
import PropTypes from 'prop-types';
import {get as _get} from 'lodash';

import {
    EVENT_INVOICE_STATUS,
} from '@constants/resources';
import {IconInfoCircleChangelog} from '@appComponents/IconCollection';
import Form from '@appComponents/ReduxFormControls';
import {GetEventInvoiceStatuses, GetStatusesForDropdown} from '@graphql/reports/query';
import {CreateInvoiceStatus, UpdateInvoiceStatus} from '@graphql/reports/mutation';
import * as messages from '@constants/messages';

import {validateMultipleInput} from './validatorInvoiceStatuses';

export default function EventsInvoiceStatusModel() {
    const renderInvoiceStatusFields = (props) => {
        let inputsToRender = [];
        const inputsData = _get(props, 'inputsData', []),
            defaultValues = {},
            data = _get(props, 'eventInvoiceStatuses', []);

        data.forEach((dataRow) => {
            defaultValues[dataRow.product.id] = {
                id: dataRow.id,
                invoice_status: dataRow.invoice_status.id,
                creation_datetime: dataRow.creation_datetime,
                creation_user: dataRow.creation_user,
                update_datetime: dataRow.update_datetime,
                update_user: dataRow.update_user,
            };
        });

        inputsData.forEach((item, index) => {
            let description = null;
            const updateTime = _get(defaultValues, `${item.id}.update_datetime`, null);

            if (updateTime) {
                description = <IconInfoCircleChangelog
                    tooltipProps={{hoverable: true, position: 'top left'}}
                    resources={EVENT_INVOICE_STATUS}
                    data={defaultValues[item.id]}
                />;
            }

            inputsToRender.push(
                <div key={`invoiceStatus${item.id}`}>
                    <Form.FormRow
                        defaultValue={_get(defaultValues, `${item.id}.id`, '')}
                        component={Form.SemanticInput}
                        name={`invoice_statuses.${index}.id`}
                        hidden={true}
                    />
                    <Form.FormRow
                        component={Form.SemanticInput}
                        defaultValue={item.id}
                        hidden={true}
                        name={`invoice_statuses.${index}.product`}
                    />
                    <Form.FormRow
                        required
                        options={props.options}
                        description={description}
                        defaultValue={_get(defaultValues, `${item.id}.invoice_status`, '')}
                        placeholder={'Select invoice status'}
                        validate={validateMultipleInput}
                        name={`invoice_statuses.${index}.invoice_status`}
                        component={Form.SemanticSelect}
                        label={item.short_name}
                    />
                </div>
            );
        });

        if (0 === inputsData.length) {
            inputsToRender = <p>This event does not contain any distribution for any invoiceable product.</p>;
        }

        return <div style={{'alignItems': 'baseline', 'flexFlow': 'column'}}>{inputsToRender}</div>;
    };

    renderInvoiceStatusFields.propTypes = {
        options: PropTypes.array,
    };

    return {
        test: {
            renderInvoiceStatusFields,
        },
        entityDataMapKey: 'eventInvoiceStatuses',
        entityLabel: 'invoice status',
        formName: 'Invoice Status',
        formValidationMessageBoxName: 'eventInvoiceStatusFormValidationBox',
        resources: EVENT_INVOICE_STATUS,
        showChangeLog: true,
        validate: validateMultipleInput,
        title: () => {
            return null;
        },
        mutation: {
            updateEntity: UpdateInvoiceStatus,
            createEntity: CreateInvoiceStatus,
        },
        query: {
            getEntity: GetEventInvoiceStatuses,
            getOptions: GetStatusesForDropdown,
        },
        messages: {
            boxName: {
                delete: 'eventsIndex',
                success: 'event',
                error: 'event',
            },
            text: messages,
        },
        dataMap: {
            eventInvoiceStatuses: {
                id: 'id',
                invoice_status: 'eventInvoiceStatuses.invoice_status.id',
                creation_datetime: 'creation_datetime',
                creation_user: 'creation_user',
                update_datetime: 'update_datetime',
                update_user: 'update_user',
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'eventInvoiceStatuses.id',
                props: {
                    label: '',
                    name: 'id',
                    hidden: true,
                },
            },
            invoice_statuses: {
                optionsKey: 'invoiceStatuses',
                dataMapKey: 'eventInvoiceStatuses',
                props: {
                    component: renderInvoiceStatusFields,
                    optionsKey: 'invoiceStatuses',
                    name: 'invoice_statuses',
                },
            },
        },
    };
}
